<template>
  <div>
    <v-tour name="modv-tour" :steps="steps" :callbacks="callbacks"></v-tour>
    <div class="shadow-overlay" @click="onDismissTour()">
      <div class="main-menu-content">
        <div id="tour-logo" class="logo"></div>
        <div id="tour-account-settings" class="account-settings"></div>
        <div id="tour-switch-organisations" class="switch-organisations"></div>
        <div id="tour-logout" class="logout"></div>
      </div>
      <div class="overlay-w-2"></div>
      <div class="sidebar-left">
        <div class="overlay-h-5"></div>
        <div id="tour-dropdown-actions" class="dropdown-actions"></div>
        <div id="tour-left-side-bar-vault" class="left-side-bar-vault"></div>
        <div id="tour-left-side-bar-document-gpt" class="left-side-bar-document-gpt"></div>
        <div id="tour-left-side-bar-recent" class="left-side-bar-recent"></div>
        <div id="tour-left-side-bar-favourite" class="left-side-bar-favourite"></div>
        <div id="tour-left-side-bar-deleted" class="left-side-bar-deleted"></div>
        <div id="tour-left-side-bar-tree" class="left-side-bar-tree"></div>
        <div class="overlay-h-3"></div>
      </div>
      <div class="file-manager-main-content">
        <div class="overlay-h-5"></div>
        <div id="tour-file-manager-content-header" class="file-manager-content-header"></div>
        <div class="file-manager-content-body">
          <div id="tour-file-manager-content-body-container" class="file-manager-content-body-container"></div>
          <div id="tour-file-manager-content-body-file-info-container" class="file-manager-content-body-file-info-container"></div>
        </div>
        <div class="overlay-h-3"></div>
      </div>
      <div class="overlay-w-2"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import VueTour from 'vue-tour'
import 'vue-tour/dist/vue-tour.css'
Vue.use(VueTour)

export default {
  components: {},
  data: function() {
    return {
      steps: [
        {
          target: '#tour-left-side-bar-vault',
          header: {
            title: 'Vaults'
          },
          content: `Think of these as external flash pens that you can use to store your documents and share with others.`
        },
        {
          target: '#tour-left-side-bar-document-gpt',
          header: {
            title: 'Document GPT'
          },
          content: `Ask any question across all your documents using the power of GPT`
        },
        {
          target: '#tour-left-side-bar-recent',
          header: {
            title: 'Recent Documents'
          },
          content: `View the documents that have recently been updated.`
        },
        {
          target: '#tour-left-side-bar-tree',
          header: {
            title: 'Document Tree'
          },
          content: `View all your documents in a tree structure.`
        },
        {
          target: '#tour-file-manager-content-header',
          header: {
            title: 'Document Search'
          },
          content: `Search for documents using the search bar.`
        },
        // {
        //   target: '#tour-file-manager-content-body-file-info-container',
        //   header: {
        //     title: 'Details panel'
        //   },
        //   content: `View the details of the selected entity.`
        // },
        {
          target: '#tour-account-settings',
          header: {
            title: 'Account Settings'
          },
          content: `View and edit your account settings.`
        },
        // {
        //   target: '#tour-switch-organisations',
        //   header: {
        //     title: 'Switch Organisations'
        //   },
        //   content: `Change the organisation you are currently working in.`
        // },
        {
          target: '#tour-logo',
          header: {
            title: 'Learn More'
          },
          content: `Click <a class="documentation-link" href="https://docs.modv.io" target="none">here</a> to learn more about the platform. <a class="documentation-link" href="https://docs.modv.io" target="none">https://docs.modv.io</a>`
        }
      ],
      callbacks: {
        onStart: this.onStart,
        onNextStep: this.onNextStep,
        onFinish: this.onFinish,
        onStop: this.onStop
      }
    }
  },
  computed: {
    ...mapState('auth', ['showTour'])
  },
  mounted: function() {
    this.$tours['modv-tour'].start()
  },
  methods: {
    onStart() {
      console.log('[Vue Tour] onStart')
      this.onInjectCSS(0)
    },
    onNextStep(currentStep) {
      this.onInjectCSS(currentStep + 1)
    },
    onFinish() {
      console.log('[Vue Tour] onFinish')
    },
    onStop() {
      console.log('[Vue Tour] onStop')
      this.$store.dispatch('auth/onEndTour', false)
    },
    onDismissTour() {
      this.$store.dispatch('auth/onEndTour', false)
    },
    onInjectCSS(index) {
      for (let i = 0; i < this.steps.length; i++) {
        const dom = document.getElementById(this.steps[i].target.replace('#', ''))
        dom.style['background-color'] = index === i ? 'transparent' : 'rgba(0, 0, 0, 0.8)'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.overlay-w-2 {
  width: 2em;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.overlay-h-3 {
  height: 3em;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.overlay-h-5 {
  height: 5em;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.shadow-overlay {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5000;
}

.main-menu-content {
  height: 100%;
  width: 80px;
  z-index: 5000;
}

.main-menu-content .logo {
  height: 5em;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.main-menu-content .account-settings {
  height: 3em;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.main-menu-content .switch-organisations {
  height: 3em;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.main-menu-content .logout {
  height: calc(100% - 5em - 3em - 3em);
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.sidebar-left {
  height: 100%;
  width: 260px;
  z-index: 5000;
}

.sidebar-left .dropdown-actions {
  height: 6em;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.sidebar-left .left-side-bar-vault {
  height: 3.1em;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.sidebar-left .left-side-bar-document-gpt {
  height: 3.1em;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.sidebar-left .left-side-bar-recent {
  height: 3.1em;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.sidebar-left .left-side-bar-favourite {
  height: 3.1em;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.sidebar-left .left-side-bar-deleted {
  height: 3.1em;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.sidebar-left .left-side-bar-tree {
  height: calc(100% - 29.5em);
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.file-manager-main-content {
  height: 100%;
  width: calc(100% - 80px - 260px - 2em - 2em);
  z-index: 5000;
}

.file-manager-main-content .file-manager-content-header {
  height: 4.5em;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.file-manager-main-content .file-manager-content-body {
  display: flex;
  height: calc(100% - 4.5em - 3em - 5em);
  z-index: 5000;
}

.file-manager-main-content .file-manager-content-body-container {
  width: calc(100% - 20em);
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.file-manager-main-content .file-manager-content-body-file-info-container {
  width: 20em;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}
</style>

<style lang="scss">
.documentation-link {
  color: white !important;
  font-weight: bold;
  text-decoration: underline !important;
}
</style>
